export const sq = {
  // Header
  header: {
    home: "Ballina",
    products: "Produktet",
    about: "Rreth Nesh",
    ourWorks: "Prodhimi",
    contact: "Kontakt",
    calculator: "Kalkulatori",
    catalog: "Katalogu",
  },
  // Banner
  banner: {
    title: "Ekselencë në prodhimin e profileve metalike premium",
    description:
      "Transformoni projektet tuaja me produktet tona me cilësi të lartë te profileve metalike. Nga fabrikimi i personalizuar deri te profilet standarde, ne ofrojmë inxhinieri të saktë dhe shërbim të jashtëzakonshëm për çdo nevojë industriale",
    contactUs: "Na Kontaktoni",
    learnMore: "Mësoni Më Shumë",
  },
  // WhoWeAre
  whoWeAre: {
    aboutUs: "Rreth nesh",
    title: "Kush jemi ne",
    description:
      "MTA është një kompani kryesuese e prodhimit të profileve metalike e dedikuar për ofrimin e produkteve me cilësi superiore dhe shërbimit të jashtëzakonshëm. Me dekada ekspertizë në fabrikimin dhe përpunimin e profileve metalike, ne kombinojmë punen tradicionale me teknologjinë moderne për të përmbushur nevojat e ndryshme të industrive nëpër Kosovë dhe më gjerë.",
    learnMore: "Mësoni Më Shumë",
    yearsOfExperience: "Vite përvojë",
    projectsPerYear: "Projekte në vit",
    clientSatisfaction: "Kënaqësia e klientit",
    tradesPerYear: "Prodhime në vit",
  },
  // QuickAbout
  quickAbout: {
    profileMetalike: "Profile metalike",
    profileMetalikeDesc:
      "Ofrojmë profile metalike me dimensione të ndryshme: 15x15 - 140x140; fi 20 deri fi150, trashësi 0.9-5mm.",
    slitingLine: "Linja sliter",
    slitingLineDesc:
      "Bëjmë prerjen e llamarinës në shirita me trashësi 0.5mm deri 10mm me gjerësi deri 1500mm",
    cutToLength: "Prerje në gjatësi",
    cutToLengthDesc:
      "Bëjmë prerjen e llamarinës (tabela), me trashësi nga 0.5-12mm, me gjerësi dhe gjatësi të ndryshme",
    pvc: "PVC",
    pvcDesc:
      "Prodhojmë të gjitha llojet e *profileve metalike* për dyert dhe dritaret PVC",
  },
  // Stats
  stats: {
    companyFounded: "Kompania u themelua",
    companyFoundedDesc:
      "MTA u themelua me një vizion për të ofruar produkte metalike me cilësi të lartë në tregun e Kosovës, duke filluar me një objektiv të vogël dhe ekip të dedikuar.",
    majorExpansion: "Zgjerim i madh",
    majorExpansionDesc:
      "Zgjëruam kapacitetin tonë të prodhimit me pajisje moderne dhe dyfishuam objektivin tonë të prodhimit për të përmbushur kërkesat në rritje të tregut.",
    industryLeadership: "Udhëheqje në industrinë",
    industryLeadershipDesc:
      "U bëmë një nga prodhuesit kryesorë të profileve metalike në Kosovë, duke shërbyer industrive të ndryshme me një gamë të gjerë produktesh dhe standarde cilësie të papërshtatshme.",
  },
  // Catalogue
  catalogue: {
    aboutUs: "Rreth nesh",
    productCatalogue: "Katalogu i produkteve",
    rectangular: "Drejtkëndore",
    rectangularDesc: "Formë e qëndrueshme ideale për struktura kornizash",
    circular: "Rrethore",
    circularDesc: "E lëmuar dhe e fortë për aplikime të lakuara",
    square: "Katror",
    squareDesc: "Dizajn i gjithanshëm për ndërtim të përgjithshëm",
    profileU: "Profili u",
    profileUDesc: "Mbështetje e qëndrueshme për aplikime universale",
    profileH: "Profili h",
    profileHDesc:
      "Profili me ngarkesë të rëndë të dizajnuar për kapacitet maksimal mbajtjeje",
    elipse: "Elips",
    elipseDesc: "Formë elegante për nevojat strukturore moderne",
    profileP: "ZP Profili",
    profilePDesc: "Profili kompakt për sisteme të ndërtuara me precizion",
    profileI: "Profili i",
    profileIDesc: "Profili i lehtë që ofron ngurtësi maksimale",
    roundBars: "Shufra të rrumbullakëta",
    roundBarsDesc:
      "Shufra metalike të forta që ofrojnë forcë dhe precizion për përdorim industrial",
    profileL: "Profili l",
    profileLDesc:
      "Dizajnuar për mbështetje të fortë dhe performancë strukturore të besueshme",
    flets: "Flats",
    fletsDesc:
      "Tabela metalike të forta dhe të lëmuara për përdorim të gjithanshëm në fabrikim",
    learnMore: "Mësoni Më Shumë",
  },
  // TradingProducts
  tradingProducts: {
    title: "Zbuloni produktet tona tregtare",
    description: "Ne si kompani tregtojmë në sasi të mëdha këto produkte",
  },
  // Factory
  factory: {
    ourFactory: "Fabrika jonë",
    title: "Si duket fabrika jonë?",
    slide1:
      "Salla jonë kryesore e prodhimit përmban makineri moderne për prerje, formim dhe përfundim të produkteve të profileve metalike me precizion dhe efikasitet",
    slide2:
      "Sistemet e avancuara të kontrollit të cilësisë sigurojnë që çdo produkt të plotësojë standardet ndërkombëtare para se të largohet nga objekti ynë.",
    slide3:
      "Ekipi ynë i dedikuar i profesionistëve të aftë operon pajisje moderne për të ofruar rezultate konsistente dhe me cilësi të lartë.",
    slide4:
      "Objektet e mëdha të magazinës na lejojnë të mbajmë inventar të gjerë dhe të sigurojmë dorëzim të shpejtë për klientët tanë.",
    slide5:
      "Departamenti ynë i fabrikimit trajton projekte të personalizuara me aftësi saldimi dhe montimi të precizionit për struktura komplekse të profileve metalike.",
  },
  // ContactForm
  contactForm: {
    title: "Le të bëhemi në kontakt",
    titleHighlight: "Le të bëhemi",
    distributorDesc:
      "Nëse jeni një distributor që dëshiron të bashkëpunojë me ne. Plotësoni detajet tuaja më poshtë, dhe ekipi ynë do të lidhet për të diskutuar mundësitë e bashkëpunimit dhe furnizimit në sasi të mëdha",
    customerDesc:
      "Nëse keni nevojë për informacion produkti, mbështetje, ose thjesht dëshironi të lidheni, ne jemi këtu për të ndihmuar. Plotësoni detajet tuaja, dhe ekipi ynë do të përgjigjet sa më shpejt që të jetë e mundur.",
    distributor: "Dristributor",
    customer: "Klient",
    name: "Emri",
    surname: "Mbiemri",
    email: "Email",
    phoneNumber: "Numri i Telefonit",
    message: "Mesazhi",
    uploadFile: "Ngarko skedarin",
    noFileChosen: "Asnjë skedar i zgjedhur",
    submitForm: "Dërgo formularin",
  },
  // Footer
  footer: {
    trustedBy:
      "E besuar nga qindra klientë nëpër rajon për angazhimin tonë për cilësi, inovacion dhe dorëzim të besueshëm në profileve metalike.",
    contactUs: "Na Kontaktoni",
    products: "Produktet",
    circular: "Rrethore",
    square: "Katror",
    rectangular: "Drejtkëndore",
    elipse: "Elips",
    profileU: "Profili u",
    profileZ: "Profili Z",
    profileP: "ZP Profili",
    socialMedia:
      "Ju mund të na vizitoni edhe në mediat tona sociale për të parë më shumë rreth nesh",
    ourSocialMedia: "Mediat tona sociale",
    allRightsReserved: "Të gjitha të drejtat e rezervuara",
  },
  // Pages
  pages: {
    about: {
      title: "Historia jonë, i cilësisë në çdo lidhje",
      description:
        "Zbuloni udhëtimin tonë nga një punishte e vogël profileve metalike në një nga kompanitë kryesore të prodhimit në Kosovë. Mësoni rreth angazhimit tonë për cilësi, inovacion dhe kënaqësinë e klientit",
    },
    products: {
      title: "Profile premium metalike për çdo aplikim",
      description:
        "Zbuloni udhëtimin tonë nga një punishte e vogël profileve metalike në një nga kompanitë kryesore të prodhimit në Kosovë. Mësoni rreth angazhimit tonë për cilësi, inovacion dhe kënaqësinë e klientit",
    },
    work: {
      title: "Trashëgimia jonë e forcës dhe precizionit",
      description:
        "Eksploroni fabrikën tonë të fabrikimit të çelikut që shërben Kosovën dhe rajonin. E pajisur me makineri moderne dhe mjeshtëri profesionale, MTA Steel ofron zgjidhje çeliku të sakta, të qëndrueshme dhe me cilësi të lartë.",
    },
  },
  // Story
  story: {
    year1999:
      "Themeloi MTA me një vizion për të ofruar produkte metalike me cilësi të lartë në tregun lokal, duke filluar me profile bazë dhe shërbime fabrikimi të personalizuara",
    year2003:
      "Zgjëruam gamën tonë të produkteve për të përfshirë profile të specializuara dhe filluam t'i shërbejmë klientëve më të mëdhenj industrialë nëpër Kosovë",
    year2007:
      "Investuam në pajisje moderne prerjeje dhe formimi, duke rritur ndjeshëm kapacitetin e prodhimit dhe standardet e cilësisë së produktit",
    year2010:
      "Dyfishuam madhësinë e objektivit tonë dhe prezantuam sisteme të avancuara kontrolli të cilësisë për të përmbushur standardet ndërkombëtare të prodhimit",
    year2014:
      "Arritëm certifikimin ISO dhe filluam eksportimin e produkteve në vendet fqinje, duke e vendosur MTA si një lojtar rajonal",
    year2018:
      "Implementuam linjat e automatizuara të prodhimit dhe menaxhimin dixhital të inventarit, duke përmirësuar efikasitetin dhe shërbimin e klientit",
    year2021:
      "Zgjëruam ekipin tonë në mbi 50 profesionistë të aftë dhe prezantuam praktika prodhimi miqësore me mjedisin",
    year2023:
      "Lansuam katalogun tonë të plotë online dhe portalin e klientit, duke e bërë më të lehtë për klientët të aksesojnë produktet tona",
    year2025:
      "Duke festuar mbi 25 vjet ekselencë, duke shërbyer qindra klientë me një gamë të gjerë produkte metalike premium",
  },
  // Values
  values: {
    ourValues: "Vlerat tona",
    title: "Për çfarë qëndrojmë",
    quality: "Cilësia",
    qualityDesc:
      "Ne kurrë nuk kompromisojmë për cilësi. Çdo produkt kalon teste dhe inspektime rigoroze për të siguruar që plotëson standardet më të larta të industrisë dhe tejkalon pritjet e klientit",
    innovation: "Inovacioni",
    innovationDesc:
      "Ne përqafojmë teknologjitë e avancuara dhe proceset moderne për të përmirësuar vazhdimisht efikasitetin, precizionin dhe performancën në çdo produkt që ne dorëzojmë",
    integrity: "Integriteti",
    integrityDesc:
      "Ne kryejmë çdo aspekt të biznesit tonë me ndershmëri, transparencë dhe përgjegjësi. Nga blerja e materialeve deri te dorëzimi i produkteve përfundimtare, ne respektojmë angazhimet tona, ndërtojmë besim me partnerët tanë dhe mbajmë standarde etike në gjithçka që bëjmë",
    excellence: "Ekselenca",
    excellenceDesc:
      "Ne kryejmë çdo aspekt të biznesit tonë me ndershmëri, transparencë dhe përgjegjësi. Nga blerja e materialeve deri te dorëzimi i produkteve përfundimtare, ne respektojmë angazhimet tona, ndërtojmë besim me partnerët tanë dhe mbajmë standarde etike në gjithçka që bëjmë",
  },
  // MainStats
  mainStats: {
    ourExpertise: "Ekspertiza jonë",
    title: "Jemi të certifikuar dhe shumë të avancuar në atë që bëjmë",
    description:
      "Angazhimi ynë për ekselencë vërtetohet nga certifikimet ndërkombëtare dhe njohja e industrisë. Ne mbajmë standardet më të larta në menaxhimin e cilësisë, protokollet e sigurisë dhe përgjegjësinë mjedisore në të gjitha operacionet",
    iso9001: "Iso 9001",
    iso9001Desc:
      "Certifikim i sistemit të menaxhimit të cilësisë që siguron cilësi konsistente në proceset tona të prodhimit",
    oshaSafety: "Siguria osha",
    oshaSafetyDesc:
      "Certifikim i administrimit të sigurisë dhe shëndetit në punë për standardet e sigurisë në vendin e punës",
    iso14001: "Iso 14001",
    iso14001Desc:
      "Certifikim i sistemit të menaxhimit mjedisor për praktika prodhimi të qëndrueshme",
  },
  // QuickOverview
  quickOverview: {
    description:
      "MTA operon me 8 linja prodhimi, 4 prej të cilave janë linja për prodhimin e profileve metalike, 2 linja sliter (linja e prerjes), dhe 1 prerje në gjatësi (prerje në linjë) të tabelave të ndryshme të llamarinës, prodhimi i profileve metalike për dyert dhe dritaret PVC, për dyert dhe dritaret PVC",
  },
  // NewBorn
  newBorn: {
    description:
      "Monumenti ikonik NEWBORN u besua me krenari kompanisë sonë për fabrikimin dhe ekzekutimin e tij, duke shënuar një projekt me kompleksitet teknik dhe vlerë simbolike. Përmes prodhimit të precizionit të profileve metalike, ekspertizës strukturore dhe përfundimit të detajuar, ne dorëzuam një monument të qëndrueshëm që reflekton kreativitet, forcë dhe dizajn modern",
  },
  // Showroom
  showroom: {
    newbornMonument: "Monumenti newborn",
    newbornMonumentDesc:
      "Furnizuar shkronja metalike me prerje të precizionit për monumentin ikonik NEWBORN të Kosovës, duke demonstruar aftësinë tonë për punë metalike arkitekturore komplekse",
  },
  // Newsletter
  newsletter: {
    title: "Gjithçka që ju nevojitet për projektet tuaja",
    description:
      "MTA ofron zgjidhje të plota metalike me inventar të gjerë, opsione personalizimi fleksibël dhe dorëzim të shpejtë. Bashkëpunoni me ne për furnizim të besueshëm, ekspertizë teknike dhe shërbim të jashtëzakonshëm gjatë gjithë ciklit të jetës së projektit tuaj",
    qualityAssurance: "Garancia e cilësisë",
    qualityAssuranceDesc:
      "Materialet premium dhe testet rigoroze sigurojnë standardet më të larta në çdo produkt që ne dorëzojmë në profileve metalike",
    expertCraftsmanship: "Ekspert",
    expertCraftsmanshipDesc:
      "Dekada përvoje të kombinuara me teknika moderne për të ofruar rezultate të jashtëzakonshme",
  },
  // SteelSupply
  steelSupply: {
    title: "Ne oferojmë furnizim të profileve metalike në shumicë",
    description:
      "Kompania jonë ofron sasi shumicë të produkteve të profileve metalike për distributor, kompani ndërtimi dhe projekte të mëdha industriale. Nëse keni nevojë për porosi në sasi të mëdha, furnizim konsistent, ose çmime të veçanta për blerje me vëllim të lartë, ekipi ynë është gati t'ju mbështesë me shërbim të besueshëm dhe efikas",
    contactUs: "Na Kontaktoni",
  },
  // Motivational
  motivational: {
    line1: "Ne nuk formojmë vetëm profile metalike",
    line2: "ne formojmë",
    line3: "FORCËN VETË",
  },
};
